import React from 'react';
import ReactDOM from 'react-dom';
import '@atlaskit/css-reset/dist/bundle.css'
// import './index.css';
import * as serviceWorker from './serviceWorker';
import { react2angular } from 'react2angular';
import angular from 'angular';

import './app/app';
import App from './react-app';

angular.module('AccountingBoxApp').component('reactApp', react2angular(App));


// import MainRouter from './modules/playground/MainRouter';

// ReactDOM.render(
//   // <React.StrictMode>
//     <App />,
//   // </React.StrictMode>,
//   document.getElementById('root')
// );


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
